import { render, staticRenderFns } from "./m-main.vue?vue&type=template&id=90690a6e"
import script from "./m-main.vue?vue&type=script&lang=js"
export * from "./m-main.vue?vue&type=script&lang=js"
import style0 from "./m-main.vue?vue&type=style&index=0&id=90690a6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports